<template>
  <div :class="modalTheme">
    <!-- <h2>USER Profile : OPTIONS #2</h2> -->

    <UserProfileOptionsAccordian  v-if="!useBAccordion"/>

     <div :class="modalTheme">
    <!-- <h2>USER Profile : OPTIONS #2</h2> -->

    <div v-if="useBAccordion" class="accordion2" role="tablist" style="background: transparent; height: 100%; max-height: 62vh; width: 100%; overflow: hidden; padding: 11px; overflow-y: auto">
      <ul class="accordion-list" :class="modalTheme">

      <!-- User Name Section -->
      <!-- <li class="accordion-item mb-1" :class="modalTheme">
        <div class="accordion-header p-1 medCard" role="tab" :class="modalTheme">
        <button
          :class="['accordion-button', modalTheme]"
          v-b-toggle.accordion-1
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-user" style="margin-right: 10px;"></i>
          <span style="padding-left: 15px">xxxUser Name</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body" style="padding: 0%" :class="modalTheme">
          <div class="container-xxl">
          <div class="row">
            <div class="col">
            <div class="container-xxl">
              <div>
              <div class="user-info">
                <div class="user-name">
                <h5>{{ userStore._user.name }}</h5>
                </div>
                <div class="logout-section">
                <LogOutButton />
                </div>
              </div>
              </div>
            </div>
            </div>
          </div>
          </div>
        </div>
        </b-collapse>
      </li> -->

      <!-- User Roles Section -->
      <li class="accordion-item mb-1" :class="modalTheme">
        <div class="accordion-header p-1 medCard" role="tab" :class="modalTheme">
        <button
          :class="['accordion-button', modalTheme]"
          v-b-toggle.accordion-2
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-user-shield" style="margin-right: 10px;"></i>
          <span style="padding-left: 15px">User Roles</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body" style="padding: 0%" :class="modalTheme">
          <div class="container-xxl">
          <div class="row">
            <div class="col">
            <div class="container-xxl">
              <div>Show list of roles assigned to the user (read only)</div>
              <div style="color: yellow">
              ROLE :
              <h6>{{ userStore.role }}</h6>
              </div>
            </div>
            </div>
          </div>
          </div>
        </div>
        </b-collapse>
      </li>

      <!-- Theme Section -->
      <li class="accordion-item mb-1">
        <div class="accordion-header p-1" role="tab">
        <button
          :class="['accordion-button', modalTheme]"
          v-b-toggle.accordion-3
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-palette" style="margin-right: 10px;"></i>
          <span style="padding-left: 15px">Theme</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body">
          <div class="accordion-content">
          <ThemeToggle />
          </div>
        </div>
        </b-collapse>
      </li>

      <!-- EMR Credentials Section -->
      <li class="accordion-item mb-1">
        <div class="accordion-header p-1" role="tab">
        <button
          :class="['accordion-button', modalTheme]"
          v-b-toggle.accordion-4
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-key" style="margin-right: 10px;"></i>
          <span style="padding-left: 15px">EMR Credentials</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body">
          <div class="accordion-content">
          <UserProfileLogin class="form" :user="userStore._user" @userProfileLogin="onSubmitUserProfileLogin" />
          </div>
        </div>
        </b-collapse>
      </li>

      <!-- For Rent Section 1 -->
      <li class="accordion-item mb-1">
        <div class="accordion-header p-1" role="tab">
        <button
          class="accordion-button"
          v-b-toggle.accordion-5
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-home" style="margin-right: 10px;"></i>
          <span>FOR RENT</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body">
          <div class="accordion-content">For Rent: 1-800-569-1234 {{ text }}</div>
        </div>
        </b-collapse>
      </li>

      <!-- For Rent Section 2 -->
      <li class="accordion-item mb-1">
        <div class="accordion-header p-1" role="tab">
        <button
          class="accordion-button"
          v-b-toggle.accordion-6
          variant="primary-green"
          type="button"
        >
          <div class="button-content">
          <i class="fas fa-building" style="margin-right: 10px;"></i>
          <span>FOR RENT</span>
          </div>
        </button>
        </div>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <div class="accordion-body">
          <div class="accordion-content">For Rent: 1-800-569-1234 {{ text }}</div>
        </div>
        </b-collapse>
      </li>

      </ul>
    </div>
    </div>

    <div v-if="useBAccordion" class="accordion2" role="tablist" style="background: transparent; height: 100%; max-height: 62vh; width: 100%; overflow: hidden; padding: 11px; overflow-y: auto">
      <b-card no-body class="mb-1" :class="modalTheme">
        <b-card-header header-tag="header" class="p-1 medCard" role="tab" :class="modalTheme">
          <b-button :class="modalTheme" block v-b-toggle.accordion-1 variant="primary-green">
            <b-row>
              <b-col cols="*" style="padding-left: 15px">xxxUser Name</b-col>
            </b-row>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body style="padding: 0%" :class="modalTheme">
            <div class="container-xxl">
              <div class="row">
                <div class="col">
                  <div class="container-xxl">
                    <div>
                      <b-row no-gutters>
                        <b-col class="text-right p-2 m-0">
                          <h5>{{ userStore._user.name }}</h5>
                        </b-col>
                        <b-col class="text-left p-0 m-0">
                          <LogOutButton />
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1" :class="modalTheme">
        <b-card-header header-tag="header" class="p-1 medCard" role="tab" :class="modalTheme">
          <b-button :class="modalTheme" block v-b-toggle.accordion-2 variant="primary-green">
            <b-row>
              <b-col cols="*" style="padding-left: 15px">User Roles</b-col>
            </b-row>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body style="padding: 0%" :class="modalTheme">
            <div class="container-xxl">
              <div class="row">
                <div class="col">
                  <div class="container-xxl">
                    <div>Show list of roles assigned to the user (read only)</div>
                    <div style="color: yellow">
                      ROLE :
                      <h6>{{ userStore.role }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button :class="modalTheme" block v-b-toggle.accordion-3 variant="primary-green">
            <b-row>
              <b-col cols="*" style="padding-left: 15px">Theme</b-col>
            </b-row>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ThemeToggle />
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button :class="modalTheme" block v-b-toggle.accordion-4 variant="primary-green">
            <b-row>
              <b-col cols="*" style="padding-left: 15px">EMR Credentials</b-col>
            </b-row>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <UserProfileLogin class="form" :user="userStore._user" @userProfileLogin="onSubmitUserProfileLogin" />
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-5 variant="primary-green">FOR RENT</b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>For Rent: 1-800-569-1234 {{ text }}</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-6 variant="primary-green">FOR RENT</b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>For Rent: 1-800-569-1234 {{ text }}</b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// ! API
import { fetchUserData, fetchSessionVariable, setUserSessionVariable } from "@/api/userApi";
import { toast } from "vue3-toastify";

import UserProfileOptionsAccordian from "./UserProfileOptionsAccordian.vue";

import DxAccordion from "devextreme-vue/accordion";
import DxTagBox from "devextreme-vue/tag-box";

import LogOutButton from "./LogOutButton.vue";
import ThemeToggle from "@/components/ThemeToggle.vue";
import UserProfileLogin from "./UserProfileLogin.vue";

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const isUserProfileSidebarOpen = ref(false);
const userSideBarWidth = ref(65);
const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
const useBAccordion = ref(false);

async function setSessionVariables(e) {
  console.clear();
// console.log("setSessionVariables : e");
  // console.dir(e);
// console.log("setSessionVariables");
// console.log("     current READS  from  usersPatStore.patientIDStartList");
  const jString = JSON.stringify(e);
// console.log("jString");
// console.log(jString);
  // // ~ OLD
  // // var arrayToString = JSON.stringify(Object.assign({}, patientStore.patientIDStartList)); // convert array to string
  // // console.log("arrayToString");
  // // console.log(arrayToString);

  // const jParse = JSON.parse(jString);
  // // console.log("jParse  > jString");
  // // console.log(jParse);

  const tPayload = { variableName: usersVariableName.value, variableValue: jString };
// console.log("tPayload  :      ");
  // console.dir(tPayload);
  // * Design criteria
  // ' string name '
  // ' { jsonContent }'

  // toast.success(" Saving  user's patient list to server.");
  // const testSET = await setUserSessionVariable(tPayload);
  // console.log("testSET");
  // console.dir(testSET);

  // console.log("  GET USER DATA  >>       userStore.fetchUserData(); ");
  // userStore.fetchUserData();

  // clearPatientList();
  // loadPatients();

  // return testSET;
}
async function getSessionVariableByName(e) {
// console.log(" getSessionVariableByName ");
  // return "TEest Get";
  // clearPatientList();

  // // console.log("runThing");
// console.log("E");
// console.log(e);

  const test = await fetchSessionVariable(e);
// console.log("test");
  // console.dir(test.payload);
  return test.payload;
  // // console.log(" Getter SET to userP id list");

  // const jsonArray = Array.from(Object.values(JSON.parse(test.payload))); // convert json to jsonobj to array
  // console.log(jsonArray);

  // // var arrayToString = JSON.parse(Object.assign({}, test.payload)); // convert array to string
  // // var arrayToString = JSON.stringify(Object.assign([], test.payload)); // convert array to string

  // // // consscriptg("arrayToString");
  // // // console.log(arrayToString);

  // // // console.log("stringToJsonObject");
  // // // console.log(stringToJsonObject);

  // //
  // usersPatStore.setUsersPatientIdList(jsonArray);

  // console.log("      >>>>>>>>>>>>>>>>                  // loadPatients();   ");
  // loadPatients();

  // return test;
}

async function onSubmitUserProfileLogin(form) {
// console.log("Form Data:", form);

  // Save userName
  const userNamePayload = {
    variableName: "userName",
    variableValue: form.userName,
  };
// console.log("Saving userName:", userNamePayload);
  toast.success("Saving user's userName to server.");
  const userNameResult = await setUserSessionVariable(userNamePayload);
// console.log("Result for userName:", userNameResult);

  // Save userPassword
  const userPasswordPayload = {
    variableName: "userPassword",
    variableValue: form.userPassword,
  };
// console.log("Saving userPassword:", userPasswordPayload);
  toast.success("Saving user's userPassword to server.");
  const userPasswordResult = await setUserSessionVariable(userPasswordPayload);
// console.log("Result for userPassword:", userPasswordResult);

  // Optionally, refresh user data or handle post-save logic here
  await userStore.fetchUserData();
}

onMounted(() => {
// console.log("onMounted() :       USER OPTIONS 2  >>>>");
// console.log(" prop   user ");
  // console.log("props : ");
  // console.log(props);
// console.log(props.user);
});
</script>

<style scoped>
.accordion-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: none;
}

.accordion-item {
  border: none;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
}

.accordion-header {
  background: transparent;
  border: none;
}

.accordion-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  border-radius: 0.375rem;
  transition: background-color 0.15s ease-in-out;
  outline: none;
}

.accordion-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

.button-content {
  width: 100%;
  display: flex;
  align-items: center;
}

.accordion-body {
  padding: 1rem;
  border: none;
  border-top: none;
}

.accordion-content {
  padding: 0.5rem 0;
}

.user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
}

.user-name {
  flex: 1;
  text-align: right;
  padding-right: 1rem;
}

.logout-section {
  flex: 0;
}

/* Remove any default list styling */
ul, li {
  list-style-type: none;
  border: none;
  outline: none;
}

/* Bootstrap margin utilities */
.mb-1 {
  margin-bottom: 0.25rem !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.text-right {
  text-align: right !important;
}

.text-left {
  text-align: left !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}
</style>